export namespace KycIdentityOriginId {
  export const Brazil = 1n;
  export const India = 2n;
  export const Mexico = 3n;
  export const Argentina = 4n;
  export const Indonesia = 5n;
  export const Peru = 6n;
  export const SouthAfrica = 7n;
  export const Nigeria = 8n;
  export const Singapore = 9n;
}

export type KycIdentityOriginIdType =
  (typeof KycIdentityOriginId)[keyof typeof KycIdentityOriginId];
